import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Image } from '@platzi/ui';
import styles from './ProjectsCard.module.sass';

export const ProjectsCard = (props) => {
  const { t } = useTranslation();

  return (
    <Card isDark customClass={styles.ProjectsCard}>
      <a target="_blank" rel="noreferrer" href={props.url}>
        <figure>
          <Image alt={props.title} src={props.image} />
        </figure>
        <div className={styles.Content}>
          <p className={styles.Title}>{props.title}</p>
          <div className={styles.UserInfo}>
            <Image alt={props.user.public_name} src={props.user.avatar} />
            <div>
              <p>{props.user.public_name}</p>
              <span>
                {t(`escuela.projectsCard.time-${props.time_data.time_type}`, { count: props.time_data.time })}
              </span>
            </div>
          </div>
        </div>
      </a>
    </Card>
  );
};
